import {
  makeStaticStyles,
  makeStyles,
  shorthands,
} from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useButtonStyles = makeStyles({
  sendButton: {
    width: "42px",
    height: "42px",
    minWidth: "42px",
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    backgroundColor: designTokens.accent[500],
    ...shorthands.border("none"),
    color: designTokens.neutral.white,
    ...shorthands.padding("0"),
    ...shorthands.margin(designTokens.spacing[4]),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: `all ${designTokens.transition.base}`,
    transform: "scale(1)",
    ":hover": {
      backgroundColor: designTokens.accent[600],
      transform: "scale(1.05)",
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },
  sendButtonMobile: {
    width: "36px",
    height: "36px",
    minWidth: "36px",
    ...shorthands.margin(designTokens.spacing[2]),
  },
  sendButtonDisabled: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
  stopButton: {
    width: "42px",
    height: "42px",
    minWidth: "42px",
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    backgroundColor: designTokens.neutral[200],
    ...shorthands.border("none"),
    color: designTokens.neutral[600],
    ...shorthands.padding("0"),
    ...shorthands.margin(designTokens.spacing[4]),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: `all ${designTokens.transition.base}`,
    ":hover": {
      backgroundColor: designTokens.neutral[300],
      transform: "scale(1.05)",
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },
  stopButtonMobile: {
    width: "36px",
    height: "36px",
    minWidth: "36px",
    ...shorthands.margin(designTokens.spacing[2]),
  },
  textArea: {
    width: "100%",
    ...shorthands.border("none"),
    outline: "none",
    backgroundColor: designTokens.neutral.white,
    resize: "none",
    fontSize: designTokens.fontSize.sm,
    minHeight: "40px",
    boxSizing: "border-box",
    paddingTop: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[3],
    ":hover": {
      ...shorthands.border("none"),
    },
    ":focus": {
      ...shorthands.border("none"),
    },
    ":focus-within": {
      ...shorthands.border("none"),
    },
    ":active": {
      ...shorthands.border("none"),
    },
  },
  textAreaMobile: {
    minHeight: "32px",
    paddingTop: designTokens.spacing[2],
    paddingBottom: designTokens.spacing[2],
  },
  textAreaEmpty: {
    textAlign: "center",
  },
});

export const useLayoutStyles = makeStyles({
  dragOverlay: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    color: designTokens.neutral.white,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    fontSize: designTokens.fontSize["2xl"],
    pointerEvents: "none",
  },
  innerTextarea: {
    lineHeight: designTokens.spacing[5],
  },
  innerTextareaBusy: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
  inputWrapper: {
    position: "relative",
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  iconsContainer: {
    position: "absolute",
    left: designTokens.spacing[3],
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center",
    ...shorthands.gap(designTokens.spacing[1]),
    zIndex: 1,
  },
  sendIcon: {
    transform: "rotate(-90deg)",
  },
});

export const useStaticStyles = makeStaticStyles(`
  .aims-chat-textarea::before,
  .aims-chat-textarea::after {
    display: none !important;
  }

  .aims-chat-textarea textarea {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    min-height: auto !important;
  }
`);
